import AlreadyRegisteredMail from './already-registered-mail';

export default AlreadyRegisteredMail;